import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "../axios";
import "../assets/styles/confirmAgree.css";
import { Country, State, City } from "country-state-city";
import { Fragment } from "react";
import { Combobox, Transition } from "@headlessui/react";

export default function ConfirmAgree() {
 
  const location= useLocation()
  const navigate= useNavigate()

  

  useEffect(() => {
    setTimeout(function () {
      if (location.state == null) {
        if (localStorage.getItem("isTrial") == "true") {
          navigate("/trial-user");
        } else if (localStorage.getItem("isTrial") == "false") {
          navigate("/subscribed-user");
        }
      } else {
        if (localStorage.getItem("dontShowProfile") == "true") {
          navigate("/Agreement", {
            state: {
              availableBalance: location.state.availableBalance,
              expiryDate: location.state.expiryDate,
              totalAssessments: location.state.totalAssessments,
            },
          });
        }
      }
    }, 100);
  }, []);

  let countryData = Country.getAllCountries();
  const [stateData, setStateData] = useState();
  const [cityData, setCityData] = useState();

  const [country, setCountry] = useState(countryData[100]);
  const [state, setState] = useState();
  const [city, setCity] = useState();
  const [salutation,setSalutation]= useState()

  useEffect(() => {
    setStateData(State.getStatesOfCountry(country?.isoCode));
  }, [country]);

  useEffect(() => {
    setCityData(City.getCitiesOfState(country?.isoCode, state?.isoCode));
  }, [state]);

  useEffect(() => {
    stateData && setState(stateData[0]);
  }, [stateData]);

  useEffect(() => {
    cityData && setCity(cityData[0]);
  }, [cityData]);

  useEffect(() => {
    getProfileApi();
  }, []);
  const [clinicName, setClinicName] = useState("");
  const [address, setAddress] = useState("");
  const [phoneNumber, setPhoneNo] = useState("");
  const [doctorName, setDoctorName] = useState("");
  const [specializations, setSpecializations] = useState("");
  const [qualifications, setQualifications] = useState("");
  const [lastname, setLastname] = useState("");
  const [userId, setUserId] = useState("");
  const [role, setRole] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  // const [checkBox, setCheckBox] = useState("checked");
  const [showError, setError] = useState(false);
  const [showClinicError, setshowClinicError] = useState(false);
  const [showAddressError, setshowAddressError] = useState(false);
  const [showPhoneError, setshowPhoneError] = useState(false);
  const [showDoctornameError, setshowDoctornameError] = useState(false);
  const [showSpecializationsError, setshowSpecializationsError] =
    useState(false);
  const [showQualificationsError, setshowQualificationsError] = useState(false);

  const [countryName, setCountryName] = useState(countryData[100].name);
  const [stateName, setStateName] = useState(
    State.getStatesOfCountry(country?.isoCode)[0].name
  );
  const [districtName, setDistrictName] = useState("Bamboo Flat");
  const handleCountryName = (val) => {
    setCountryName(val);
  };
  const handleStateName = (val) => {
    setStateName(val);
  };
  const handleDistrictName = (val) => {
    setDistrictName(val);
  };
 
  const handleSalutation=(e)=>{
    setSalutation(e.target.value)
  }

  const nameChange=(e)=>{
    const { value } = e.target;

    const re = /^[A-Za-z]+$/;
    if (value === "" || re.test(value)) {
      setDoctorName(value);
    }
  }
  

  const submit = (event) => {
    console.log(clinicName);
    if (
      clinicName.length == 0 ||
      address.length == 0 ||
      phoneNumber.length < 10 ||
      doctorName.length == 0 ||
      specializations.length == 0 ||
      qualifications.length == 0
    ) {
      if (clinicName.length == 0) {
        setshowClinicError(true);
      } else {
        setshowClinicError(false);
      }
      if (address.length == 0) {
        setshowAddressError(true);
      } else {
        setshowAddressError(false);
      }
      if (phoneNumber.length < 10) {
        setshowPhoneError(true);
      } else {
        setshowPhoneError(false);
      }
      if (doctorName.length == 0) {
        setshowDoctornameError(true);
      } else {
        setshowDoctornameError(false);
      }
      if (specializations.length == 0) {
        setshowSpecializationsError(true);
      } else {
        setshowSpecializationsError(false);
      }
      if (qualifications.length == 0) {
        setshowQualificationsError(true);
      } else {
        setshowQualificationsError(false);
      }
    } else {
      setError(false);
      postProfileApi();
    }
  };


  const getProfileApi = () => {
   
    axios
      .get("/getProfile", {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "*",
          accessToken: localStorage.getItem("accessToken"),
        },
      })
      .then((response) => {
        console.log(response);
        // setClinicName(response.data.data.hospitals);
        // setAddress(response.data.data.locations);
        console.log(response.data.data.contact)
        setPhoneNo(response.data.data.contact);
        setDoctorName(response.data.data.firstname);
        // setSpecializations(response.data.data.specializations);
        // setQualifications(response.data.data.qualifications);
        setLastname(response.data.data.lastname);
        setUserId(response.data.data.loginId);
        setRole(response.data.data.role);
        setSalutation(response.data.data.salutation)
        
        
      });
  };

  const postProfileApi = () => {
    console.log(salutation)
    if (isChecked) {
      let formData = {
        firstname: doctorName,
        contact: phoneNumber,
        locations: address,
        hospitals: clinicName,
        qualifications: qualifications,
        specializations: specializations,
        lastname: lastname,
        userId: userId,
        country: countryName,
        state: stateName,
        district: districtName,
        salutation:salutation,
    
      };
      axios
        .post("/updateProfile", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "*",
            accessToken: localStorage.getItem("accessToken"),
          },
        })
        .then((response) => {
          console.log("Response: ", response);
          localStorage.setItem("userName", doctorName);
          localStorage.setItem("address", address);
          localStorage.setItem("clinicName", clinicName);
          localStorage.setItem("role", role);
          localStorage.setItem("isTrial", false);
          localStorage.setItem("dontShowProfile", true);
          navigate("/Agreement", {
            state: {
              availableBalance: location.state.availableBalance,
              expiryDate: location.state.expiryDate,
              totalAssessments: location.state.totalAssessments,
            },
          });
        });
    }
  };

  const checkBoxEvent = (event) => {
    setIsChecked(event.target.checked);
  };
// console.log(salutation)
  return location.state == null ? (
    <div></div>
  ) : (
    <div>
      
      <div className="confirmAgree">
        <p className="confirmAgree-PurchasingPlan" style={{fontWeight:'bold'}}>Update Profile</p>
        <p className="confirmAgree-Please-check">
          Please check below info you have already provided to us.<br></br>
          Confirmed data will be used in agreement.
        </p>
        {/* {showError ? <p>Please fill all the fields</p> : ""} */}
        <p style={{textAlign:'center', margin:'auto'}} >
          <span class="marquee-text" style={{color:'red', fontWeight:'bolder'}} >Please do not press back button</span>
        </p>
        <form style={{width:'100%'}}>
          <div className="confirmAgree-main-rect">
            <span className="confirmAgree-main-rect-textName">
              Hospital<span style={{ color: "red" }}>*</span>
            </span>
            <div>
              <input
                className={
                  showError
                    ? "confirmAgree-main-rect-inputbox-error"
                    : "confirmAgree-main-rect-inputbox"
                }
                type="text"
                name="name"
                placeholder="Enter Name"
                value={clinicName}
                onChange={(e) => setClinicName(e.target.value)}
              />
            </div>
            {showClinicError ? (
              <span className="confirmAgree-main-rect-error-text">
                Please enter Hospital name<br></br>
              </span>
            ) : (
              ""
            )}
            <span className="confirmAgree-main-rect-textName">
              Address<span style={{ color: "red" }}>*</span>
            </span>
            <div>
              <input
                className={
                  showError
                    ? "confirmAgree-main-rect-inputbox-error"
                    : "confirmAgree-main-rect-inputbox"
                }
                type="text"
                name="address"
                placeholder="Enter Address"
                onChange={(e) => setAddress(e.target.value)}
                value={address}
              />
            </div>
            {showAddressError ? (
              <span className="confirmAgree-main-rect-error-text">
                Please enter Address<br></br>
              </span>
            ) : (
              ""
            )}
            <span className="confirmAgree-main-rect-textName">
              Phone number<span style={{ color: "red" }}>*</span>
            </span>
            <div>
              <input
                className={
                  showError
                    ? "confirmAgree-main-rect-inputbox-error"
                    : "confirmAgree-main-rect-inputbox"
                }
                type="text"
                name="number"
                placeholder="Enter Phone number"
                onChange={(e) => setPhoneNo(e.target.value)}
                value={phoneNumber}
              />
            </div>
            {showPhoneError ? (
              <span className="confirmAgree-main-rect-error-text">
                Please enter a valid phone number<br></br>
              </span>
            ) : (
              ""
            )}
            <span className="confirmAgree-main-rect-textName">
             Name<span style={{ color: "red" }}>*</span>
            </span>
            <div style={{display:'flex', padding:'5px 0px'}} className={
                  showError
                    ? "confirmAgree-main-rect-inputbox-error"
                    : "confirmAgree-main-rect-inputbox"
                } >
            <select style={{border:'0px', paddingLeft:'5px', borderTopLeftRadius:'8px', borderBottomLeftRadius:'8px'}} value={salutation} onChange={handleSalutation}>
              <option value='Mr.'>Mr.</option>
              <option value='Ms.'>Ms.</option>
              <option value='Mrs.'>Mrs.</option>
              <option value='Dr.'>Dr.</option>
            </select>
            <div>
            <input       
                type="text"
                name="doctor"
                placeholder="Enter Doctor Name"
                value={doctorName}
                onChange={nameChange}
                style={{borderTopLeftRadius:'0px', borderBottomLeftRadius:'0px', border:'none',}}
                className='doctor-name'
              />
            </div>

            </div>
            {showDoctornameError ? (
              <span className="confirmAgree-main-rect-error-text">
                Please enter Doctor name<br></br>
              </span>
            ) : (
              ""
            )}
            <span className="confirmAgree-main-rect-textName">
              Specialization<span style={{ color: "red" }}>*</span>
            </span>
            <div>
              <input
                className={
                  showError
                    ? "confirmAgree-main-rect-inputbox-error"
                    : "confirmAgree-main-rect-inputbox"
                }
                type="text"
                name="specializations"
                placeholder="Enter Specialization"
                onChange={(e) => setSpecializations(e.target.value)}
                value={specializations}
              />
            </div>
            {showSpecializationsError ? (
              <span className="confirmAgree-main-rect-error-text">
                Please enter specialization<br></br>
              </span>
            ) : (
              ""
            )}
            <span className="confirmAgree-main-rect-textName">
              Qualification<span style={{ color: "red" }}>*</span>
            </span>
            <div>
              <input
                className={
                  showError
                    ? "confirmAgree-main-rect-inputbox-error"
                    : "confirmAgree-main-rect-inputbox"
                }
                type="text"
                name="qualifications"
                placeholder="Enter Qualification"
                onChange={(e) => setQualifications(e.target.value)}
                value={qualifications}
              />
            </div>
            {showQualificationsError ? (
              <span className="confirmAgree-main-rect-error-text">
                Please enter qualification<br></br>
              </span>
            ) : (
              ""
            )}
            <div className="flex flex-wrap gap-3 bg-teal-300 rounded-lg p-8">
              <div>
                <span className="confirmAgree-main-rect-textName">
                  Country<span style={{ color: "red" }}>*</span>
                </span>
                <Selector
                  data={countryData}
                  selected={country}
                  setSelected={setCountry}
                  type={"country"}
                  handleNames={handleCountryName}
                />
              </div>
              {state && (
                <div style={{ marginTop: "10px" }}>
                  <span className="confirmAgree-main-rect-textName">
                    State<span style={{ color: "red" }}>*</span>
                  </span>
                  <Selector
                    data={stateData}
                    selected={state}
                    setSelected={setState}
                    type={"state"}
                    handleNames={handleStateName}
                  />
                </div>
              )}
              {city && (
                <div style={{ marginTop: "10px" }}>
                  <span className="confirmAgree-main-rect-textName">
                    District<span style={{ color: "red" }}>*</span>
                  </span>
                  <Selector
                    data={cityData}
                    selected={city}
                    setSelected={setCity}
                    type={"district"}
                    handleNames={handleDistrictName}
                  />
                </div>
              )}
            </div>
            <br></br>
            <div style={{ display: "flex", gap: "10px", alignItems: "center", }}>
              <input
                type="checkbox"
                className="confirmAgree-main-rect-checkbox"
                onChange={(event) => {
                  checkBoxEvent(event);
                }}
              />
              <span className="confirmAgree-main-rect-I-agree">
                I agree to use this info in the agreement.
              </span>
            </div>
            <br></br>
            <div className="confirmAgree-main-rect-next-page">
              {isChecked ? (
                <span
                  className="confirmAgree-main-rect-next-page-Confirm-gen"
                  onClick={submit}
                >
                  Confirm & generate agreement
                </span>
              ) : (
                <span
                  style={{ cursor: "not-allowed" }}
                  className="confirmAgree-main-rect-next-page-Confirm-gen"
                >
                  Confirm & generate agreement
                </span>
              )}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

function Selector({ data, selected, setSelected, type, handleNames }) {
  const [query, setQuery] = useState("");

  const filteredPeople =
    query === ""
      ? data
      : data.filter((person) =>
          person.name
            .toLowerCase()
            .replace(/\s+/g, "")
            .includes(query.toLowerCase().replace(/\s+/g, ""))
        );

  const ComboboxChange = (value) => {
    setQuery(value.target.value);
    console.log("type:", type);
    handleNames(value.target.value);
  };

  return (
    <div className="w-72">
      <Combobox value={selected} onChange={setSelected}>
        <div className="relative mt-1">
          <div
            style={{ display: "flex" }}
            className="relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-teal-300 sm:text-sm"
          >
            <Combobox.Input
              className="w-full combobox-input  outline-none border-none pl-3 pr-10 text-sm leading-5 text-gray-900 focus:ring-0"
              displayValue={(person) => person.name}
              onSelect={(event) => ComboboxChange(event)}
            />
            <Combobox.Button className="absolute inset-y-0 right-0 flex items-center pr-2">
              {/* <ChevronUpDownIcon
                className="h-5 w-5 text-gray-400 hover:text-gray-500"
                aria-hidden="true"
              /> */}
              <img
                className="h-5 img-dropdown w-5 text-gray-400 hover:text-gray-500"
                src="https://cdn-icons-png.flaticon.com/512/2618/2618316.png"
              />
            </Combobox.Button>
          </div>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            afterLeave={() => setQuery("")}
          >
            <Combobox.Options className="absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
              {filteredPeople.length === 0 && query !== "" ? (
                <div className="relative cursor-default select-none py-2 px-4 text-gray-700">
                  Nothing found.
                </div>
              ) : (
                filteredPeople.map((person) => (
                  <Combobox.Option
                    key={person.id}
                    className={({ active }) =>
                      `relative cursor-default select-none py-2 pl-10 pr-4 ${
                        active ? "bg-teal-400 text-white h-50" : "text-gray-500 h-50"
                      }`
                    }
                    value={person}
                  >
                    {({ selected, active }) => (
                      <>
                        <span
                          className={`block truncate ${
                            selected ? "font-medium" : "font-normal"
                          }`}
                        >
                          {person.name}
                        </span>
                        {selected ? (
                          <span
                            className={`absolute inset-y-0 left-0 flex items-center pl-3 ${
                              active ? "text-white" : "text-teal-600"
                            }`}
                          >
                            {/* <CheckIcon className="h-5 w-5" aria-hidden="true" /> */}
                          </span>
                        ) : null}
                      </>
                    )}
                  </Combobox.Option>
                ))
              )}
            </Combobox.Options>
          </Transition>
        </div>
      </Combobox>
    </div>
  );
}
